/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // Services
  @service
  features;

  @service
  store;

  model() {
    let financeModel = this.modelFor('people.person.finance');

    let promises = {
      person: financeModel.person,
      accounts: financeModel.accounts,
      items: this.store.query('finance/line-item', {
        learnerIds: JSON.stringify(financeModel.personIds),
        include: 'transactions',
      }),
      ledgerItems: this.store.query('finance/ledger-item', {
        year: moment().year(),
      }),
      futureLedgerItems: this.store.query('finance/ledger-item', {
        year: moment().year() + 1,
      }),
      ledgers: this.store.findAll('finance/ledger'),
    };

    if (this.features.sapFinance) {
      // Add extra SAP entities if required.
      promises.costCentres = this.store.findAll('finance/cost-centre');
      promises.internalOrders = this.store.findAll('finance/internal-order');
    }

    return hash(promises);
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.reset();
    this.controller.set(
      'hideArchivedLineItems',
      this.controller.get('personOptions.hideArchivedLineItems'),
    );
  }

  resetController(controller) {
    controller.reset();
    this.controller.set(
      'hideArchivedLineItems',
      this.controller.get('personOptions.hideArchivedLineItems'),
    );
  }
}
